import { createReducer } from '@reduxjs/toolkit';

import LoadingStatus from '@libs/loading-status';

import { CONTRACT_AUTHENTICATION_INITIALIZE } from '@app/store/actionTypes';
import { fetchContractAuthentication } from '@app/store/contract-authentication/actions';

type ContractAuthenticationLoadingStatusState = LoadingStatus;

const initialState: ContractAuthenticationLoadingStatusState = LoadingStatus.IDLE;

const reducer = createReducer<ContractAuthenticationLoadingStatusState>(initialState, (builder) =>
  builder
    .addCase(CONTRACT_AUTHENTICATION_INITIALIZE, () => LoadingStatus.IDLE)
    .addCase(fetchContractAuthentication.pending, () => LoadingStatus.PENDING)
    .addCase(fetchContractAuthentication.fulfilled, () => LoadingStatus.SUCCEEDED)
    .addCase(fetchContractAuthentication.rejected, () => LoadingStatus.FAILED)
);

export default reducer;
